import type { LDReactClient } from '@launchdarkly/react-sdk';
import {
  flagNamesToObject,
  type FlagNamesToObjectOutput,
  FlagType
} from 'integrations/launchDarkly/impl/flagNamesToObject';
import { useEffect, useState } from 'react';
import { useDarklyMock } from '../legacy/useDarklyMock';

export function useDarklyImpl<FLAG_NAME extends string, TYPE extends FlagType>(
  client: LDReactClient,
  flagNames: FLAG_NAME[],
  type: TYPE
) {
  const mock = useDarklyMock();
  const [flags, setFlags] = useState(() => {
    if (!client.isReady()) {
      return {} as FlagNamesToObjectOutput<FLAG_NAME, TYPE>;
    }
    return flagNamesToObject(client, flagNames, type);
  });

  useEffect(() => {
    if (!client.isReady()) {
      client.waitForInitialization().then((e) => {
        setFlags(flagNamesToObject(client, flagNames, type));
      });
      return;
    }
    function updateFlags() {
      setFlags(flagNamesToObject(client, flagNames, type));
    }
    client.on('change', updateFlags);
    return () => {
      client.off('change', updateFlags);
    };
  }, [client, flagNames, type]);

  if (mock.enabled) {
    return mock.flags as FlagNamesToObjectOutput<FLAG_NAME, TYPE>;
  }

  return flags;
}
